import { Box, Divider, Stack } from "@mui/material";
import dayjs from "dayjs";
import { Fragment } from "react";
import { dateTimeConversionService } from "../../../shared/services/DateTimeConversionService";
import { PortfolioItemModel } from "../types/PortfolioItemModel";
import { portfolioItemMappers } from "../mappers/PortfolioItemMappers";
import {
    portfolioCalculationService
} from "../../../shared/services/portfolio-calculation-service/PortfolioCalculationService";

export function PositionTooltipTitle({
    portfolioItemModel
}: {
    portfolioItemModel: PortfolioItemModel
}) {
    function getExpirationDateInfoText(expirationDate: Date | null): string | null {
        if (expirationDate === null)
            return null;

        const expirationDateJs = dayjs(expirationDate);
        
        return expirationDateJs.diff(dateTimeConversionService.getCurrentUtcDate(), 'hours') < 48
            ? `${expirationDateJs.format("dddd DD.MMM.YYYY HH:mm:ss")} (${expirationDateJs.diff(dateTimeConversionService.getCurrentUtcDate(), 'hours')} h)`
            : `${expirationDateJs.format("dddd DD.MMM.YYYY HH:mm:ss")} (${expirationDateJs.diff(dateTimeConversionService.getCurrentUtcDate(), 'days')} d)`;
    }

    return (
        <Fragment>
            <Box sx={{fontSize: "13px", fontWeight: "600"}}>Position parameters</Box>
            <Divider sx={{ paddingTop: "5px", borderColor: '#f2f3f3' }}/>
            <Stack direction="row" sx={{fontSize: "13px", paddingTop: "5px"}}>
                <Box width="110px">Id:</Box><div>{portfolioItemModel.externalId}</div>
            </Stack>
            <Stack direction="row" sx={{fontSize: "13px"}}>
                <Box width="110px">Asset type:</Box><div>{portfolioItemMappers.getTypeStringValue(portfolioItemModel.type)}</div>
            </Stack>
            {
                portfolioItemModel.strike &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Strike:</Box><div>{portfolioItemModel.strike}</div>
                </Stack>
            }
            {
                portfolioItemModel.expireAt &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Expiry date:</Box><div>{getExpirationDateInfoText(portfolioItemModel.expireAt)}</div>
                </Stack>
            }
            {
                portfolioItemModel.expirationPrice &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Expiry price:</Box>{portfolioItemModel.expirationPrice.toFixed(2)}
                </Stack>
            }
            {
                portfolioItemModel.expirationPrice &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Balance:</Box>{
                        portfolioCalculationService.balance
                            .calculateOrderBalanceAfterExpiration(portfolioItemModel).toFixed(2)
                    }
                </Stack>
            }
            <Stack direction="row" sx={{fontSize: "13px"}}>
                <Box width="110px">Open date:</Box><div>{dateTimeConversionService.convertDateToCustomFormattedString(portfolioItemModel.openedPositionAt, "dddd DD.MMM.YYYY HH:mm:ss")}</div>
            </Stack>
            {
                portfolioItemModel.underlyingPriceAtOpen &&
                <Stack direction="row" sx={{fontSize: "13px"}}>
                    <Box width="110px">Underlying price:</Box><div>{portfolioItemModel.underlyingPriceAtOpen?.toFixed(2) ?? ' '}</div>
                </Stack>
            }
        </Fragment>
    )
}